import React from 'react'

const Section3 = () => {
  return (
    <>
<section class="pt-12.5">
      <div class="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0">
        <div class="grid sm:grid-cols-12 gap-7.5" data-highlighter="">
          {/* <!-- features item --> */}
          <div class="sm:col-span-12">
            <div class="relative rounded-3xl features-box-border">
              <div class="relative overflow-hidden rounded-3xl p-10 xl:p-15 box-hover">
                <div class="flex items-center justify-between relative z-20">
                  <div class="max-w-[477px] w-full">
                    <span class="hero-subtitle-gradient relative mb-4 font-medium text-sm inline-flex items-center gap-2 py-2 px-4.5 rounded-full">
                      <img src="images/icon-title.svg" alt="icon"/>

                      <span class="hero-subtitle-text">
                    
                      </span>
                    </span>
                    <h3 class="text-white mb-4.5 font-bold text-heading-4">
                      Explore Courses
                    </h3>
                    <p class="font-medium mb-10">
                    Discover a wide range of courses across various subjects that cater to your learning needs and aspirations.
                     
                    </p>
                    <a href="#" class="features-button-gradient relative inline-flex items-center gap-1.5 rounded-full py-3 px-6 text-white text-sm ease-in duration-300 hover:shadow-button">
                      Learn more
                      <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.3992 5.60002L8.22422 0.350024C7.99922 0.125024 7.64922 0.125024 7.42422 0.350024C7.19922 0.575024 7.19922 0.925025 7.42422 1.15002L11.6242 5.42503H0.999219C0.699219 5.42503 0.449219 5.67502 0.449219 5.97502C0.449219 6.27502 0.699219 6.55003 0.999219 6.55003H11.6742L7.42422 10.875C7.19922 11.1 7.19922 11.45 7.42422 11.675C7.52422 11.775 7.67422 11.825 7.82422 11.825C7.97422 11.825 8.12422 11.775 8.22422 11.65L13.3992 6.40002C13.6242 6.17502 13.6242 5.82502 13.3992 5.60002Z" fill="white"></path>
                      </svg>
                    </a>
                  </div>

                  <div class="hidden sm:block">
                    <img src="/images/logo (2).png" alt="icon" className='h-[50px]'/>
                  </div>
                </div>

                {/* <!-- bg shapes --> */}
                <div class="absolute -z-10 pointer-events-none inset-0 overflow-hidden -mx-28">
                  <span class="absolute right-0 bottom-0"><img src="images/shape-01.png" alt="shape"/></span>
                  <span class="absolute left-0 top-0"><img src="images/shape-02.svg" alt="shape"/></span>
                  <span class="absolute left-1/2 -translate-x-1/2 bottom-0">
                    <img src="images/blur-03.svg" alt="blur" class="max-w-none"/>
                  </span>
                  <span class="absolute left-1/2 -translate-x-1/2 bottom-0">
                    <img src="images/blur-04.svg" alt="blur" class="max-w-none"/>
                  </span>
                  <span class="absolute left-1/2 -translate-x-1/2 bottom-0">
                    <img src="images/blur-05.svg" alt="blur" class="max-w-none"/>
                  </span>
                  <span class="absolute right-0 top-0">
                    <img src="images/shape-03.svg" alt="shape" class="max-w-none"/>
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- features item --> */}
          <div class="sm:col-span-7">
            <div class="relative rounded-3xl features-box-border">
              <div class="relative overflow-hidden rounded-3xl px-11 pt-12.5 pb-14 box-hover box-hover-small">
                <div class="relative z-20">
                  <span class="icon-border relative max-w-[80px] w-full h-20 rounded-full inline-flex items-center justify-center mb-13.5 mx-auto">
                    <img src="images/icon-05.svg" alt="icon"/>
                  </span>

                  <h3 class="text-white mb-4.5 font-semibold text-heading-6">
                  Empowering Learners
                  </h3>
                  <p class="font-medium">
                  Equip yourself with the knowledge and skills needed to succeed in today’s digital world. Learn at your own pace, anytime, anywhere.
                  
                  </p>
                </div>

                {/* <!-- bg shapes --> */}
                <div class="absolute -z-10 pointer-events-none inset-0 overflow-hidden">
                  <span class="absolute left-0 bottom-0">
                    <img src="images/blur-06.svg" alt="blur" class="max-w-none"/>
                  </span>
                  <span class="absolute right-0 top-0">
                    <img src="images/blur-07.svg" alt="blur" class="max-w-none"/>
                  </span>
                  <span class="absolute right-[16%] top-[16%]"><img src="images/shape-04.svg" alt="shape"/></span>
                  <span class="absolute left-0 bottom-0">
                    <img src="images/blur-08.svg" alt="blur" class="max-w-none"/>
                  </span>
                  <span class="absolute left-0 bottom-0">
                    <img src="images/blur-09.svg" alt="blur" class="max-w-none"/>
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- features item --> */}
          <div class="sm:col-span-5">
            <div class="relative rounded-3xl features-box-border">
              <div class="relative overflow-hidden rounded-3xl px-11 pt-12.5 pb-14 box-hover box-hover-small">
                <div class="relative z-20">
                  <span class="icon-border relative max-w-[80px] w-full h-20 rounded-full inline-flex items-center justify-center mb-13.5 mx-auto">
                    <img src="images/icon-07.svg" alt="icon"/>
                  </span>

                  <h3 class="text-white mb-4.5 font-semibold text-heading-6">
                    Quizes & Assessments
                  </h3>
                  <p class="font-medium">
                  Test your knowledge and understanding with interactive quizzes and assessments.
                   
                  </p>
                </div>

                {/* <!-- bg shapes --> */}
                <div class="absolute -z-10 pointer-events-none inset-0 overflow-hidden">
                  <span class="absolute right-[14%] top-[17%]"><img src="images/shape-05.svg" alt="shape"/></span>
                  <span class="absolute left-0 bottom-0">
                    <img src="images/blur-10.svg" alt="blur" class="max-w-none"/>
                  </span>
                  <span class="absolute top-0 right-0">
                    <img src="images/blur-11.svg" alt="blur" class="max-w-none"/>
                  </span>
                  <span class="absolute top-0 right-0">
                    <img src="images/blur-12.svg" alt="blur" class="max-w-none"/>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>      
    </>
  )
}

export default Section3
